import { Box, makeStyles, Paper } from '@material-ui/core';
import {
  FlightTakeoffOutlined as AirplaneIcon,
  LocalShippingOutlined as TruckIcon,
  DirectionsBoatOutlined as ShipIcon,
} from '@material-ui/icons';
import { useMemo } from 'react';
import TextOrLoading from './TextOrLoading';

const useStyles = makeStyles({
  container: {
    height: '100%',
    borderRadius: 12,
  },
  buttonContainer: {
    paddingTop: 12,
    paddingBottom: 12,
    paddingLeft: 18,
    paddingRight: 18,
    width: '100%',
    height: '100%',
    background: 'none',
    border: 'none',
    borderRadius: 12,
    cursor: 'pointer',
    position: 'relative',
  },
  header: { display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: 32 },
  iconContainer: { display: 'flex', flexDirection: 'column', alignItems: 'center', paddingLeft: 12, paddingRight: 12 },
  row: { display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-evenly' },
  title: { display: 'block', fontSize: 16, textAlign: 'center' },
  numberInfo: { display: 'block', fontSize: 20, fontWeight: 'bold' },
  icon: { fontSize: 40, marginBottom: 8, opacity: 0.9 },
  light: { color: '#fff' },
  spaceBetween: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: '100%',
  },
  triangleIndicator: {
    position: 'absolute',
    bottom: -32,
    left: '50%',
    transform: 'translateX(-50%)',
  },
});

export default function GestaoAVistaEtapaCard({
  name,
  total,
  totalAereo,
  totalMaritimo,
  totalRodoviario,
  backgroundColor = '#24517a',
  light = true,
  loading = true,
  selected = false,
  noneSelected = false,
  onSelectedChange = () => {},
}) {
  const classes = useStyles();

  const innerBoxClasses = useMemo(() => {
    let newClass = classes.spaceBetween;

    if (light) newClass = `${newClass} ${classes.light}`;

    return newClass;
  }, [light]);

  return (
    <>
      <Paper
        elevation={5}
        className={classes.container}
        style={{
          backgroundColor,
          opacity: selected || noneSelected ? 1 : 0.8,
        }}
      >
        <button type="button" className={classes.buttonContainer} onClick={onSelectedChange}>
          <Box className={innerBoxClasses}>
            <Box className={classes.header}>
              <span className={classes.title}>{name}</span>
              <TextOrLoading loading={loading}>
                <strong className={classes.numberInfo}>{total}</strong>
              </TextOrLoading>
            </Box>

            <Box className={classes.row}>
              <Box className={classes.iconContainer}>
                <AirplaneIcon className={classes.icon} />
                <TextOrLoading loading={loading}>
                  <strong className={classes.numberInfo}>{totalAereo}</strong>
                </TextOrLoading>
              </Box>

              <Box className={classes.iconContainer}>
                <ShipIcon className={classes.icon} />
                <TextOrLoading loading={loading}>
                  <strong className={classes.numberInfo}>{totalMaritimo}</strong>
                </TextOrLoading>
              </Box>

              <Box className={classes.iconContainer}>
                <TruckIcon className={classes.icon} />
                <TextOrLoading loading={loading}>
                  <strong className={classes.numberInfo}>{totalRodoviario}</strong>
                </TextOrLoading>
              </Box>
            </Box>
          </Box>

          {selected ? (
            <div className={classes.triangleIndicator}>
              <svg width="16" height="16" viewBox="0 0 120 120">
                <path
                  d="M 60 10 L 110 100 L 10 100 Z"
                  fill={backgroundColor}
                  stroke="black"
                  strokeWidth="2"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          ) : null}
        </button>
      </Paper>
    </>
  );
}
